module.exports = __webpack_public_path__ + "static/img/reactfolio-low-resolution-logo-color-on-transparent-background.8c5ac0a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reactfolio-low-resolution-logo-color-on-transparent-background.svg
// module id = X/cS
// module chunks = 1